import React, { useEffect, useState } from "react";
import { Button, DownloadIcon } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import { useGetIvideonLogFileHash } from "~/entity/Logs";
import { DataFilterIProps } from "~/entity/Logs/model/schema";
import { useNotify } from "~/shared/hooks/useNotify";

interface ButtonsBlockProps {
  /** Текущие параметры фильтра (из URL), с которыми формируется отчёт. */
  dataFilter?: DataFilterIProps;
}

const ButtonsBlock = ({ dataFilter }: ButtonsBlockProps) => {
  const { t } = useTranslation();
  const { notifyReport } = useNotify();
  const [send, setSend] = useState(false);
  const { data: fileHash } = useGetIvideonLogFileHash({ send, dataFilter });

  const getReport = () => {
    setSend(true);
  };

  useEffect(() => {
    if (fileHash) {
      setSend(false);
      notifyReport(fileHash);
    }
  }, [fileHash]);

  return (
    <Button
      color="secondary"
      variant="filled"
      bold
      fontSize="12"
      size="middle"
      radius={30}
      icon={<DownloadIcon size={16} fill="#495a64" />}
      onClick={getReport}
    >
      {t("logs.reportExcel")}
    </Button>
  );
};

export default ButtonsBlock;
